var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModerators(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 2.87502C15.6667 3.45028 15.2003 3.91669 14.6251 3.91669C14.6186 3.91669 14.6132 3.91339 14.6068 3.91329L13.2911 11.1503C13.2188 11.5443 12.8751 11.8334 12.4714 11.8334H3.86206C3.45946 11.8334 3.11414 11.5453 3.04227 11.1492L1.7269 3.91408C1.72039 3.91408 1.71493 3.91669 1.68498 3.91669C1.10972 3.91669 0.643311 3.45028 0.643311 2.87502C0.643311 2.29976 1.13315 1.83335 1.68498 1.83335C2.2368 1.83335 2.72664 2.29976 2.72664 2.87502C2.72664 3.10934 2.63495 3.31486 2.50433 3.48882L4.83844 5.35601C5.25276 5.68752 5.86709 5.55247 6.10433 5.07788L7.60433 2.07788C7.30998 1.89429 7.10164 1.58179 7.10164 1.20835C7.10164 0.633093 7.59123 0.166687 8.16675 0.166687C8.74227 0.166687 9.18498 0.633093 9.18498 1.20835C9.18498 1.58179 8.97761 1.89429 8.68237 2.07815L10.1824 5.07815C10.4196 5.55262 11.0342 5.68752 11.4483 5.35627L13.7824 3.48908C13.6746 3.31512 13.5834 3.08596 13.5834 2.87502C13.5834 2.2995 14.0496 1.83335 14.6251 1.83335C15.2006 1.83335 15.6667 2.2995 15.6667 2.87502Z",
    fill: "#A4AFC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModerators);
export default __webpack_public_path__ + "static/media/moderators.a97befb88c8a5a73b9317da1b92b3c7b.svg";
export { ForwardRef as ReactComponent };